export function getDocumentCookieHeader(): string {
  try {
    return globalThis.document?.cookie ?? "";
  } catch {
    return "";
  }
}

export function getCookieValueFromHeader(cookieHeader: string, cookieName: string): string | null {
  const cookiePrefix = `${cookieName}=`;
  const matchingCookie = cookieHeader
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(cookiePrefix));

  if (!matchingCookie) {
    return null;
  }

  try {
    return decodeURIComponent(matchingCookie.slice(cookiePrefix.length));
  } catch {
    return null;
  }
}

function buildCookieValue(
  cookieName: string,
  cookieValue: string,
  hostname = globalThis.location?.hostname ?? "",
  protocol = globalThis.location?.protocol ?? ""
): string {
  const cookieAttributes = [
    `${cookieName}=${encodeURIComponent(cookieValue)}`,
    "path=/",
    "max-age=31536000",
    "SameSite=Lax",
  ];

  if (hostname === "vaultn.com" || hostname.endsWith(".vaultn.com")) {
    cookieAttributes.push("domain=.vaultn.com");
  }

  if (protocol === "https:") {
    cookieAttributes.push("Secure");
  }

  return cookieAttributes.join("; ");
}

export function getCookieValue(cookieName: string): string | null {
  return getCookieValueFromHeader(getDocumentCookieHeader(), cookieName);
}

export function setCookieValue(cookieName: string, value: string): void {
  try {
    globalThis.document.cookie = buildCookieValue(cookieName, value);
  } catch {
    return;
  }
}
